import { Check, Eye, X } from "lucide-react";
import { InlineActionButton } from "@/components/ui/InlineActionButton";

type ReturnDecisionActionsProps = {
  isBusy: boolean;
  canReplace: boolean;
  canCancel: boolean;
  onOpenTargetOrder: () => void;
  onToggleSubstitution: () => void;
  onCancelReturn: () => void;
};

export function ReturnDecisionActions({
  isBusy,
  canReplace,
  canCancel,
  onOpenTargetOrder,
  onToggleSubstitution,
  onCancelReturn,
}: ReturnDecisionActionsProps) {
  return (
    <>
      <InlineActionButton onClick={onOpenTargetOrder} icon={<Eye size={12} />}>
        Ver carga
      </InlineActionButton>
      {canReplace ? (
        <InlineActionButton
          tone="success"
          onClick={onToggleSubstitution}
          disabled={isBusy}
          icon={<Check size={12} />}
        >
          Substituir
        </InlineActionButton>
      ) : null}
      {canCancel ? (
        <InlineActionButton
          tone="neutral"
          aria-label="Cancelar item"
          onClick={onCancelReturn}
          disabled={isBusy}
          icon={<X size={12} />}
        >
          Cancelar item
        </InlineActionButton>
      ) : null}
    </>
  );
}
